import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import NotificationComponent from '../components/notificationComponent';
import {getAllNotification,getNotificationCount,updateUnReadNotification} from '../actions/notificationAction';

class NotificationContainer extends Component {
    constructor(props){
        super(props);
    }
    componentWillMount(){
        this.props.actions.getNotificationCount();
    }
    notificationList = (requestPayload) =>{
        this.props.actions.getAllNotification(
            requestPayload,
            this.props.dispatch
        ) 
    }
    readNotification = (requestPayload) =>{
        this.props.actions.updateUnReadNotification(
            requestPayload,
            this.props.dispatch
        )
    }
    render() {
        return(
            <div>
                <NotificationComponent
                    notificationData={this.props.notificationData}
                    notificationList={this.notificationList}
                    readNotification={this.readNotification}
                >
                </NotificationComponent>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getAllNotification,
            getNotificationCount,
            updateUnReadNotification
        }, dispatch)
    };
};

function mapStateToProps({NotificationReducer}) {
    console.log(NotificationReducer)
    return {
        notificationData : {
            message : NotificationReducer.message,
            errorCode : NotificationReducer.errorCode,
            statusCode : NotificationReducer.statusCode,
            notificationList : NotificationReducer.notificationList,
            count : NotificationReducer.count
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NotificationContainer)) 